import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M21.1921 5.46453C21.5826 5.85505 21.5826 6.48822 21.1921 6.87874L9.94907 18.1218C9.51949 18.5513 8.82301 18.5513 8.39343 18.1218L2.80729 12.5356C2.41677 12.1451 2.41677 11.5119 2.80729 11.1214C3.19781 10.7309 3.83098 10.7309 4.2215 11.1214L9.17125 16.0711L19.7779 5.46453C20.1684 5.074 20.8016 5.074 21.1921 5.46453Z"
	})
});
export default SvgCheckLine;
